import React from 'react';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

const EmptyMyChat = () => {
  return (
    <div className={cx('emptyArea')}>
      아직 참여한 채팅이 없어요.
      <br />
      함께 채용정보를 나눠보세요!
    </div>
  );
};

export default EmptyMyChat;
